module.exports = __webpack_public_path__ + "static/media/ArialMTLight.082a0403.woff";